"use client"

import Link from "next/link"

type MetadataItem = {
  id: string
  name: string
  title: string
  filter: string
}

type MoreLinksProps = {
  data?: {
    metadata?: MetadataItem[]
  }
}

export default function MoreLinksMain({ data }: MoreLinksProps) {
  const groupedLinks: {
    city: MetadataItem[]
    brand: MetadataItem[]
    use: MetadataItem[]
    price: MetadataItem[]
    others: MetadataItem[]
  } = {
    city: [],
    brand: [],
    use: [],
    price: [],
    others: [],
  }

  // Categorize metadata items
  data?.metadata?.forEach((item) => {
    const name = item?.name ?? ""

    if (name.startsWith("best-refurbished-laptops-in-")) {
      groupedLinks.city.push(item)
    } else if (/^refurbished-[a-z0-9-]+-laptops$/i.test(name)) {
      groupedLinks.brand.push(item)
    } else if (name.startsWith("refurbished-laptops-for-")) {
      groupedLinks.use.push(item)
    } else if (name.startsWith("refurbished-laptops-under-")) {
      groupedLinks.price.push(item)
    } else {
      groupedLinks.others.push(item)
    }
  })

  const renderSection = (title: string, items: MetadataItem[]) =>
    items?.length > 0 && (
      <div className="mb-6">
        <h3 className="text-sm md:text-base lg:text-lg xl:text-xl font-gilroySemiBold text-white mb-2">
          {title}
        </h3>
        <ul>
          {/* {JSON.stringify(items[0])} */}

          {items.map((item) => (
            <li
              key={item?.id || Math.random().toString()}
              className="font-gilroySemiBold text-xs lg:text-sm xl:text-base text-[#999] leading-5 xl:py-[0.3rem] py-0.5"
            >
              <Link
                prefetch={false}
                href={`/${
                  item?.filter
                    ? `${item?.name}${item?.filter}`
                    : item?.name || "#"
                }`}
              >
                {item?.title?.replace(/\s*\|\s*Edify\.club\s*$/i, "") ||
                  "Untitled"}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    )

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 px-4 w-full h-[11rem] overflow-y-scroll text-white">
        {renderSection("Refurbished Laptops by City", groupedLinks.city)}
        {renderSection("Refurbished Laptops by Brands", groupedLinks.brand)}
        {renderSection("Refurbished Laptops by Use", groupedLinks.use)}
        {renderSection("Refurbished Laptops by Price", groupedLinks.price)}
        {renderSection("Other Links", groupedLinks.others)}
      </div>
      <div className="h-[1px] bg-slate-800 px-2 lg:px-4" />
    </>
  )
}
